import { useEffect, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useNotifications } from 'app/application/application'
import { formatNumber } from 'app/common/presentation/format'
import { useConnections } from 'app/connections/application'
import { useAnalytics } from 'app/dashbaord/application'
import { MatchingRate } from 'app/dashbaord/types'

import { ProgressBar } from 'components'

import Tile, { TileContentProps } from './Tile'
import styles from './Tile.module.scss'

const MatchingRatio = ({ days, translate }: TileContentProps) => {
  const { connections: connections } = useConnections()
  const { fetchMatchingRatio } = useAnalytics()
  const { t: st } = useTranslation('connections')
  const { createNotification, te } = useNotifications()

  const [matchingRate, setMatchingRate] = useState<MatchingRate>()

  useEffect(() => {
    if (connections.length) {
      void fetchMatchingRatio(days, connections).then((result) =>
        result.ok
          ? setMatchingRate(result.val)
          : createNotification({
              message: result.val.message,
              title: te(`http.${result.val.code}`),
              type: 'error',
            }),
      )
    }
  }, [createNotification, days, fetchMatchingRatio, connections, te])

  const eventStatistics = useMemo(
    () =>
      matchingRate
        ? Object.entries(matchingRate)
            .sort(([_, a], [__, b]) => b - a)
            .slice(0, 5)
        : [],
    [matchingRate],
  )

  return (
    <Tile
      className={styles.matchingRatio}
      days={days}
      tileKey="matchingRatio"
      translate={translate}
    >
      <div className={styles.conversions}>
        {eventStatistics.map(([connectionName, ratio], index) => (
          <div className={styles.conversion} key={index}>
            <div>
              <div>{st(`available.${connectionName}.displayName`)}</div>
              <div>{formatNumber(ratio, 'percent')}</div>
            </div>
            <ProgressBar percentage={ratio} progressClassName={styles.progress} />
          </div>
        ))}
      </div>
    </Tile>
  )
}

export default MatchingRatio
